import React, {Component} from "react";

export class ExperienceContainer extends Component {
    render() {
        return (
            <div>
                <h2>Experience</h2>
            </div>
        )
    }
}

class Showcase extends Component {
    render() {
        return (
          <div>

          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/MainPages/Experience.js